export const createSubaccountName = (name: string, type: string) => {
	return `${name} - ${type}`;
};